import { Component } from '@angular/core';
import { ICellRendererAngularComp, IHeaderAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, IHeaderParams } from 'ag-grid-community';
import { DocResourceStatus } from 'it/primatoo/openapi/api/org/schemas/common/DocResourceStatus';

@Component({
  selector: 'pt-status-formatter-renderer',
  template: `
    <ng-container [ngSwitch]='params?.data?.status'>
      <ng-container *ngSwitchCase='DocResourceStatus.PUBLISHED'>
        <span class='badge rounded-pill bg-primary'
        >{{ params?.value }}</span>
      </ng-container>

      <ng-container *ngSwitchCase='DocResourceStatus.DRAFT'>
        <span class='badge rounded-pill bg-warning text-dark'
        >{{ params?.value }}</span>
      </ng-container>
    </ng-container>
  `
})
export class StatusFormatterRendererComponent implements ICellRendererAngularComp, IHeaderAngularComp {

  params: any;
  DocResourceStatus = DocResourceStatus;

  agInit(params: any): void {
    this.params = params;
  }

  refresh(params: ICellRendererParams): boolean;
  refresh(params: IHeaderParams): boolean;
  refresh(params: ICellRendererParams | IHeaderParams): boolean {
    return false;
  }

}

